<template>
    <div class="order">
        <!-- <div class="title">
            <div>Nicle Han Makeup Studio</div>
            <div class="title-text">今日订单</div>
        </div> -->

        <div class="order-item" v-for="item in orderQuestionList" :key="item.id">
            <div class="order-title">
                <div style="width: 30px;color: #f19c9d;margin-left: 5px;">#{{ item.id }}</div>
                <div style="width: 150px;">{{ item.user_nickname }}</div>
                <div style="width: 200px;">{{ item.service_name }}</div>
                <div style="width: 100px;">{{ item.makeup_girl_name }}</div>
                <div style="width: auto;">{{ item.store_name }}</div>
            </div>
            <div>{{ item.appointment_time }}</div>
        </div>
    </div>
</template>

<script>
import reqApi from "@/api/api.js";
export default {
    name: "OrderItem",
    components: {},
    data() {
        return {
            orderQuestionList: [],
        };
    },
    created() {
    },
    mounted() {
        this.getOrderQuestion();
    },
    methods: {
        getOrderQuestion() {
            reqApi.orderQuestion({}).then((res) => {
                this.orderQuestionList = res.data;
            });
        },
    },
};
</script>

<style scoped>
.order {
    padding-bottom: 200px;
}

.order .title {
    font-size: 34px;
    color: #000000;
    text-align: center;
    padding: 30px 0;
}

.order .title .title-text {
    font-size: 24px;
    color: #000000;
    text-align: center;
    margin-top: 15px;
}

.order-item {
    font-size: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    margin: 10px;
    background-color: #fff;
    border-radius: 5px;
}

.order-title {
    display: flex;
    align-items: center;
}

.order-title>div {
    margin-right: 30px;
}
</style>
